"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ScoreBar = require("./ScoreBar");
Object.keys(_ScoreBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScoreBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ScoreBar[key];
    }
  });
});